export default function WhatsAppButton() {
  const phoneNumber = '522291578562';
  const message = encodeURIComponent('Hola! Estoy visitando el sitio de VIP Luxury Cars MKS y me gustaría alquilar un vehículo de lujo. ¿Pueden asesorarme sobre disponibilidad y precios?');

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transition-all hover:scale-110 cursor-pointer group"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl"></i>
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-black text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Reserva por WhatsApp
      </span>
    </a>
  );
}